import ServiceApi from "../services/service.api";
import ServiceStorage from "./../services/service.storage";

const baseServiceUrl = `/api/v1/Home`;


const ApiHome = {
  getInfos: (params) => {
    const url = `${baseServiceUrl}`;
    var hh = ServiceApi.get(url, { params });
    return hh;
  },
 getGlobalSearch: (params) => {
    
    const url = `${baseServiceUrl}/GetGlobalSearch`;
    
    return ServiceApi.get(url, { params: { globalSearch: params } });
  },
  pageNotFound: (params) => {
    
    const url = `${baseServiceUrl}/pageNotFound`;
    
    return ServiceApi.get(url, params);
  },
  setPromoCode:(promoCode)=>{
    ServiceStorage.setPromoCode(promoCode);

  },
  getPromoCode:()=>{
   return ServiceStorage.getPromoCode();
    
  },
  getPromoCodeDate:()=>{
    return ServiceStorage.getPromoCodeDate();
     
   }
};

export default ApiHome;